import React from 'react';
import AppsTileList from './components/AppsTileList';
import useApps from '../hooks/useApps';
import CommonLayout from '../components/CommonLayout';

const GuestApps = () => {
  const { apps, loading, error } = useApps();

  if (error) {
    return <div>Error fetching apps</div>;
  }

  return (
    <div>
      <AppsTileList apps={apps} loading={loading} />
    </div>
  );
};

export default GuestApps;